/**
* Animated Steps JS
* -----------------------------------------------------------------------------
*
* All the JS for the Animated Steps component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'animated-steps',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
        $( '.animated-steps' ).each( function( key, component ) {
          let rotation = component.style.getPropertyValue( '--rotation' );
          if ( window.hasMotion ) {
            const docStyle = getComputedStyle( document.documentElement );
            const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
            const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
            const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );

            const panelsCount = $( this ).find( '.panel' ).length;
            $( component ).height( $( component ).find( '.panel' ).height() * panelsCount );

            // pin the component
            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: component,
                pin: $( component ).find( '.panels' )[0],
                start: 'top ' + topOffset,
                end: 'bottom bottom',
                scrub: 0,
              },
            } );

            $( component ).find( '.panel' ).each( function( panelKey, panel ) {
              let image = $( panel ).find( '.fit-image' )[0];
              if ( $( panel ).find( '.loop-video-container' ).length ) {
                image = $( panel ).find( '.loop-video-container' )[0];
              }
              const height = $( panel ).outerHeight() / 2;
              const panelContent = $( panel ).find( '.content' );

              // reveal the circle image and content
              const tl = gsap.timeline( {
                scrollTrigger: {
                  trigger: component,
                  start: ( height * panelKey ) + ' ' + topOffset,
                  end: '+=' + height,
                  onLeave: ( self ) => {
                    if ( $( component ).find( '.panel' ).length !== panelKey + 1 ) {
                      $( panelContent ).removeClass( 'is-active' );
                    }
                  },
                  onEnter: ( self ) => {
                    if ( panelKey !== 0 ) {
                      rotation = rotation.split( 'deg' )[0];
                      rotation = `${parseInt( rotation ) - 90}deg`;
                      component.style.setProperty( '--rotation', rotation );
                    }

                    $( panelContent ).addClass( 'is-active' );
                  },
                  onLeaveBack: ( self ) => {
                    if ( panelKey !== 0 ) {
                      $( panelContent ).removeClass( 'is-active' );
                    }
                  },
                  onEnterBack: ( self ) => {
                    if ( $( component ).find( '.panel' ).length !== panelKey + 1 ) {
                      rotation = rotation.split( 'deg' )[0];
                      rotation = `${parseInt( rotation ) + 90}deg`;
                      component.style.setProperty( '--rotation', rotation );
                      $( panelContent ).addClass( 'is-active' );
                    }
                  },
                  scrub: 0,
                },
              } );

              // here's the revealing of the image
            } );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'animated-steps', COMPONENT );
} )( app );
